/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getProductRegistrationStatement } from '../fn/registration-statement/get-product-registration-statement';
import { GetProductRegistrationStatement$Params } from '../fn/registration-statement/get-product-registration-statement';
import { StatementResponse } from '../models/statement-response';


/**
 * Registration statement endpoints. Requires PRODUCT_ADMIN or EASYLOT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class RegistrationStatementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProductRegistrationStatement()` */
  static readonly GetProductRegistrationStatementPath = '/statements/actual';

  /**
   * Gets registration statement.
   *
   * Finds and returns the current registration statement.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductRegistrationStatement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductRegistrationStatement$Response(params?: GetProductRegistrationStatement$Params, context?: HttpContext): Observable<StrictHttpResponse<StatementResponse>> {
    const obs = getProductRegistrationStatement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets registration statement.
   *
   * Finds and returns the current registration statement.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductRegistrationStatement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductRegistrationStatement(params?: GetProductRegistrationStatement$Params, context?: HttpContext): Observable<StatementResponse> {
    const resp = this.getProductRegistrationStatement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StatementResponse>): StatementResponse => r.body)
    );
  }

}
